import React from 'react';
import { FormProvider, useForm } from "react-hook-form";
import CollectInfo from './CollectInfo';
import WayCollectInfo from './WayCollectInfo';
import LegitimateSources from './LegitimateSources';
import PublicSources from './PublicSource';
import RequiredByLaw from './RequiredByLaw';
import RequiredByContract from './RequiredByContract';
import WizardButtons from '@/Wizard/WizardButtons';
import { NextButton, PrevButton, ResetButton } from '@/Shared/Buttons';
import { actions, useStore } from "@/store";
import { informationFormSchema } from '@/schema';
import { yupResolver } from '@hookform/resolvers/yup';
import Input from '@/Shared/Form/Input';

const InformationStep = ({ stepName }) => {
  const [
    informationFormValue, 
    setInformationFormValue
  ] = useStore(state => [state.informationFormValue, state.setInformationFormValue])

  const formMethods = useForm({
    mode: 'onBlur',
    shouldFocusError: false,
    defaultValues: informationFormValue,
    resolver: yupResolver(informationFormSchema),
  });

  const onSubmit = (data) => {
    setInformationFormValue(data)
    actions.handleWizardNextStep()
  }

  return (
    <FormProvider {...formMethods}>
      <form onSubmit={formMethods.handleSubmit(onSubmit)}>
        <div className="card shadow-lg">
          <div className="card-header">
            <h3 className="card-title">
              Specify what information about your users do you collect and how it is collected.
            </h3>
          </div>
          <div className="card-body">
            <div className='row'>
              <div className='col-lg-6 col-md-6 col-sm-12'>
                <p className='fw-bold required'>What information do you collect?</p>
                <div className='d-flex flex-column'>
                  <CollectInfo />
                </div>
              </div>
              <div className='col-lg-6 col-md-6 col-sm-12'>
                <p className='fw-bold required'>How do you collect the information?</p>
                <div className='d-flex flex-column'>
                  <WayCollectInfo />
                </div>
                <p className='fw-bold mt-5'>Do you obtain user personal data from other legitimate sources?</p>
                <div className='d-flex flex-column'>
                  <LegitimateSources />
                </div>
                <p className='fw-bold mt-5'>Data collected from public sources?</p>
                <div className='d-flex flex-column'>
                  <PublicSources />
                </div>
                <p className='fw-bold mt-5'>
                  Is the user required to provide any personal data by law?
                  <span className='fw-normal'>(e.g. for tax compliance, identity verification)</span>
                </p>
                <div className='d-flex flex-column'>
                  <RequiredByLaw />
                </div>
                <p className='fw-bold mt-5'> Is the user required to provide any personal data to enter into or perform a contract?</p>
                <div className='d-flex flex-column'>
                  <RequiredByContract />
                </div>
                {(formMethods.watch('requiredByLaw') || formMethods.watch('requiredByContract')) && (
                  <div className='mt-5'>
                    <Input
                      labelText='What are the consequences if the user does not provide this data?'
                      name='consequencesIfNotProvidedValue'
                      type='text'
                      placeholder='e.g., "The user will not be able to access premium features or receive our services."'
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className='card-footer'>
            <WizardButtons>
              <PrevButton onClick={() => actions.handleWizardPrevStep()} />
              <ResetButton onClick={() => actions.handleWizardReset()} />
              <NextButton type='submit' />
            </WizardButtons>
          </div>
        </div>
      </form>
    </FormProvider>
  )
}

export default InformationStep;